export default "__VITE_ASSET__CMUQms0A__"